export interface VoiceSelection {
  id: string;
  voice_id: string;
  provider_voice_id?: string | null;
  name: string;
  isRecommended?: boolean;
}

export const normalizeVoiceSelection = (
  storedVoiceId: string | null | undefined,
  voices: VoiceSelection[]
): string => {
  if (!storedVoiceId) return '';
  const normalizedStored = storedVoiceId.trim().toLowerCase();
  const match = voices.find((voice) =>
    [voice.voice_id, voice.id, voice.provider_voice_id, voice.name]
      .filter(Boolean)
      .some((value) => String(value).trim().toLowerCase() === normalizedStored)
  );
  return match?.voice_id || storedVoiceId;
};

export const defaultVoiceSelection = (voices: VoiceSelection[]): string =>
  voices.find((voice) => voice.isRecommended === true)?.voice_id || '';
